import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { AddIcon } from '@diligentcorp/atlas-react-icons';
import { paths } from '@issuemanager/apps/client/paths';
import { useTranslation } from 'react-i18next';

export function IssuesGridToolbarAddIssue() {
  const { t } = useTranslation(['issue']);

  return (
    <Link to={`/${paths.issues.create}`}>
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        data-testid='add-issue-button'
      >
        {t('issue:form.new.title')}
      </Button>
    </Link>
  );
}
